import * as constants from "./actions";
import axios from "@/plugins/axios.js";

function getDefaultState() {
  return {
    fees: {
      status: null,
      data: [],
      error: null,
    },

    fee: {
      status: null,
      data: {},
      error: null,
    },
  };
}
const actions = {
  [constants.GET_FEES]: async ({ commit }, payload) => {
    try {
      commit(constants.GET_FEES);

      const response = await axios.get("fees/getFees", {
        params: payload,
      });
      commit(constants.GET_FEES_SUCCESS, response);
      commit;
      return response;
    } catch (error) {
      commit(constants.GET_FEES_ERROR, error);
      throw error.response;
    }
  },
  [constants.POST_FEE]: async ({ commit }, payload) => {
    try {
      commit(constants.POST_FEE);
      const response = await axios.post("fees/createAndUpdate", payload);
      commit(constants.POST_FEE_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.POST_FEE_ERROR, error);
      throw error.response;
    }
  },
};

const mutations = {
  [constants.GET_FEES]: (state) => {
    state.fees.data = [];
    state.fees.status = "fetching";
  },
  [constants.GET_FEES_SUCCESS]: (state, response) => {
    state.fees.status = "success";
    state.fees.data = response;
  },
  [constants.GET_FEES_ERROR]: (state, error) => {
    state.fees.status = "error";
    state.fees.error = error;
  },
  [constants.POST_FEE]: (state) => {
    state.fee.data = {};
    state.fee.status = "fetching";
  },
  [constants.POST_FEE_SUCCESS]: (state, response) => {
    state.fee.status = "success";
    state.fee.data = response;
  },
  [constants.POST_FEE_ERROR]: (state, error) => {
    state.fee.status = "error";
    state.fee.error = error;
  },
};
export default {
  state: getDefaultState(),
  actions,
  mutations,
};
